import React, { FC } from 'react';
import { ProjectDueDateChanged } from 'api/notifications/meta';
import { ProjectFieldChangedMessage } from './project-field-changed';

export const ProjectDueDateChangedView: FC<{
  meta: ProjectDueDateChanged;
}> = ({ meta: { by, from, to } }) => (
  <ProjectFieldChangedMessage by={by} name="due_date" from={from} to={to} />
);
